<script>
import Calendar from '@/components/Calendar'
import DOMUtils from '@/utils/DOMUtils'
import DialogUtils from '@/utils/dialogUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import EnvironmentUtils from '@/utils/environmentUtils'
import StringUtils from '@/utils/stringUtils'
import DateUtils from '@/utils/dateUtils'
import EventsServices from '@/services/events'

export default
{
    name: 'edit-events',

    render () 
    {
        return (
            <div id='edit-events'>
                <Calendar id='calendar' ref='calendar' events={this.$store.state.events.eventList} editable={true}
                    on-save-changes-clicked={this.onSaveChangesClicked} on-add-new-event={this.onAddNewEvent} on-delete-clicked={this.onDeleteClicked} />
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    mounted ()
    {
        window.onbeforeunload = () =>
        {
            if (this.$refs.calendar.hasUnsavedModifications) 
            {
                return 'Vous avez fait des modifications non enregistrées, souhaitez-vous quand même quitter cette page ?'
            }
        }
    },

    beforeRouteEnter (to, from, next)
    {
        next(vm =>
        {
            if (LocalStorageUtils.useIntensiveAnimations && vm.calendar != undefined)
            {
                DOMUtils.animateCSS(vm.$refs.calendar.$el, 'zoomIn', '0.3s')
            }
        })
    },

    async beforeRouteLeave (to, from, next)
    {
        const hasUnsavedWork = this.$refs.calendar.hasUnsavedModifications
        if (!hasUnsavedWork) return next()

        const message = 'Vous avez fait des modifications non enregistrées.\nVoulez-vous continuer ?'
        const answer =  await DialogUtils.waitForUserConfirmationAsync({description: message})
        
        if (answer)
        {
            next()
        }
        else
        {
            next(false)
        }
    },

    beforeDestroy ()
    {
        window.onbeforeunload = null
    },

    methods:
    {
        async createEvent (event)
        {
            const created = await EventsServices.createEvent(event, EnvironmentUtils.cityId, this.$store.state.user.token)
            await this.$store.commit('events/updateEventList', [created])

            this.$ga.event('event', 'create', this.$store.state.user.username, created.id)

            return created
        },

        async onSaveChangesClicked (event, e, button)
        {
            button.showSpinnerWhile(async () =>
            {
                console.log('Saving changes for event', event)
                this.$ga.event('event', 'click:save', this.$store.state.user.username, event.id)

                if (StringUtils.isEmptyString(StringUtils.removeHtmlTags(event.title)))
                    return this.$toast.warning('Votre événement doit avoir un titre')
                if (StringUtils.isEmptyString(StringUtils.removeHtmlTags(event.description)))
                    return this.$toast.warning('Votre événement doit avoir une description')
                if (!DateUtils.isValidDate(event.date))
                    return this.$toast.warning('Votre événement doit avoir une date valide')
                if (event.scheduledPublishingDate && event.scheduledPublishingDate < new Date())
                    return this.$toast.warning('La date de publication ne peut pas être dépassée')

                if (event.isUncreated)
                {
                    await this.createEvent(event)
                    this.$store.dispatch('events/removeEventById', event.id)
                
                    return
                }

                const updated = await EventsServices.updateEvent(event.id, event, EnvironmentUtils.cityId, this.$store.state.user.token)
                await this.$store.commit('events/updateEventList', [updated])
            })
        },

        async onAddNewEvent ()
        {
            const newEventDate = this.$refs.calendar.selectedDate == 'all' ? new Date() : this.$refs.calendar.selectedDate

            const newEvent = { 
                date: newEventDate, id: -Math.floor(Math.random() * 10000), isUncreated: true }
            
            await this.$store.commit('events/updateEventList', [newEvent])
        },

        async onDeleteClicked (event)
        {
            console.log('Deleting event', event)
            this.$ga.event('event', 'click:delete', this.$store.state.user.username, event.id)
            this.$ga.event('event', 'delete', this.$store.state.user.username, event.id)


            const confirmation = await DialogUtils.waitForUserConfirmationAsync({ description: 'Voulez-vous vraiment supprimer cet événement ?' })
            if (!confirmation) return console.log('User aborted deletion')
            
            if (!event.isUncreated)
            {
                await EventsServices.deleteEvent(event.id, EnvironmentUtils.cityId, this.$store.state.user.token)
            }

            this.$store.dispatch('events/removeEventById', event.id)
        }
    },

    components:
    {
        Calendar
    }
}
</script>

<style lang='less' scoped>
@import '~@/styles/main.less';

#edit-events
{
    margin-top: 4vh;

    .OnDesktop({
        margin-top: 0;
        border-left: var(--theme-vertical-menu-total-vertical-space) solid transparent;
    });
}
</style>



// WEBPACK FOOTER //
// src/views/EditEvents.vue